(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sg-contact-cta"] && !Shopify.designMode) return;
  try {
    
(function() {
  var revealEls = document.querySelectorAll('.sg-reveal');
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) e.target.classList.add('sg-visible');
      });
    }, { threshold: 0.1 });
    revealEls.forEach(function(el) { obs.observe(el); });
  } else {
    revealEls.forEach(function(el) { el.classList.add('sg-visible'); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-contact-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── Scroll reveal ── */
  var revealEls = document.querySelectorAll('.sg-reveal');
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('sg-visible'); });
    }, { threshold: 0.1 });
    revealEls.forEach(function (el) { obs.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('sg-visible'); });
  }

  /* ── Office click-to-reveal ── */
  document.querySelectorAll('.sg-office-reveal').forEach(function (el) {
    function doReveal() {
      var span = el.querySelector('.sg-reveal-text');
      if (!span) return;
      if (el.classList.contains('sg-revealed')) { window.location.href = el.dataset.href; return; }
      span.textContent = el.dataset.reveal;
      el.classList.add('sg-revealed');
    }
    el.addEventListener('click', doReveal);
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); doReveal(); }
    });
  });

  /* ── Contact form: honeypot guard + checkbox aggregation + loading state ── */
  document.querySelectorAll('.sg-contact-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {

      /* 1. Honeypot — silently abort if filled (bot) */
      var hp = form.querySelector('input[name="contact[_hp]"]');
      if (hp && hp.value !== '') { e.preventDefault(); return; }

      /* 2. Aggregate checked service checkboxes into the hidden field.
            The hidden field's name is "contact[Services of Interest]",
            which Shopify will include as a labelled line in the email:
            "Services of Interest: Lighting Control, Home Cinema" */
      var checked = [].slice.call(form.querySelectorAll('.sg-service-cb:checked'))
                      .map(function (cb) { return cb.value; });
      var hidden = form.querySelector('[name="contact[Services of Interest]"]');
      if (hidden) hidden.value = checked.length ? checked.join(', ') : 'None selected';

      /* 3. Button loading state — prevents double-submit */
      var btn = form.querySelector('.sg-form-submit');
      if (btn) {
        var lbl = btn.querySelector('.sg-form-submit__label');
        var snd = btn.querySelector('.sg-form-submit__sending');
        btn.disabled = true;
        if (lbl) lbl.hidden = true;
        if (snd) snd.hidden = false;
      }

    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-contact-methods"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Scroll reveal
  var revealEls = document.querySelectorAll('.sg-reveal');
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) e.target.classList.add('sg-visible');
      });
    }, { threshold: 0.1 });
    revealEls.forEach(function(el) { obs.observe(el); });
  } else {
    revealEls.forEach(function(el) { el.classList.add('sg-visible'); });
  }

  // Reveal cards (phone / email)
  document.querySelectorAll('.sg-method-card--reveal').forEach(function(card) {
    card.addEventListener('click', function() {
      var detail = card.querySelector('.sg-method-card__detail--hidden');
      if (!detail) return;
      if (detail.classList.contains('sg-method-card__detail--revealed')) {
        window.location.href = card.dataset.href;
        return;
      }
      detail.textContent = card.dataset.reveal;
      detail.classList.remove('sg-method-card__detail--hidden');
      detail.classList.add('sg-method-card__detail--revealed');
    });
    card.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.click(); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
